import { UiSchema } from '@rjsf/core';
import { JSONSchema } from './RJSF';

/**
 * Adds context properties to schema, for use in rule conditions.
 * FormField component will hide context field based on idSchema ("root_context").
 */
export const applyContext = (contextSchema: JSONSchema | {}, schema: JSONSchema, uiSchema: UiSchema = {}) => {
    return {
        schema: {
            ...schema,
            properties: {
                ...schema.properties,
                context: contextSchema
            }
        },
        uiSchema
    }
}

/**
 * Drops context from formData
 * @param prevFormData 
 */
export const removeContextData = (formData: any) => {
    let newFormData = { ...formData }
    delete newFormData.context
    return newFormData
}
